import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-site',
  templateUrl: './web-site.component.html',
  styleUrls: ['./web-site.component.css']
})
export class WebSiteComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
